"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9874],{

/***/ 39766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    height: 50px;\n    margin-top: 20px;\n    border: none;\n    border-radius: 8px;\n    color: white;\n    background-color: ",
        ";\n    font-family: NotoSansKR;\n    font-size: 16px;\n    font-weight: bold;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.38;\n    letter-spacing: -0.64px;\n    text-align: center;\n    cursor: pointer;\n    &:disabled {\n      background-color: #bbbbbb;\n      cursor: default;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SignupSubmitButton = function(param) {
    var _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "가입 완료" : _buttonText;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .Gc)(), _formState = ref.formState, errors = _formState.errors, isValid = _formState.isValid, isSubmitting = _formState.isSubmitting, isSubmitted = _formState.isSubmitted;
    var canSubmit = !Object.keys(errors).length && isValid && !isSubmitting && !isSubmitted;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledWrapper, {
        type: "submit",
        disabled: !canSubmit,
        children: buttonText
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SignupSubmitButton);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    displayName: "SignupSubmitButton__StyledWrapper",
    componentId: "sc-dcd302f1-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), theme.color.primary_2);
});


/***/ }),

/***/ 97020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87536);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30132);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: relative;\n\n    .join-input {\n      width: 100%;\n      height: 50px;\n      padding: 0 16px;\n      border-radius: 8px;\n      border: solid 1px ",
        ";\n      font-size: 16px;\n      &:focus {\n        outline: none;\n        border: solid 1px ",
        ";\n      }\n      &.error-input {\n        border: solid 1px ",
        ";\n      }\n    }\n    > span.input-message {\n      display: block;\n      height: 17px;\n    }\n    .error-message {\n      font-size: 12px;\n      font-weight: normal;\n      line-height: 17px;\n      letter-spacing: -0.48px;\n      text-align: left;\n      color: ",
        ";\n    }\n    i.check-svg {\n      position: absolute;\n      top: calc(50% - 14px);\n      right: 20px;\n      display: flex;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InputText = function(_param) {
    var fieldName = _param.fieldName, placeholder = _param.placeholder, handleInputChange = _param.onInputChange, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "fieldName",
        "placeholder",
        "onInputChange"
    ]);
    var ref, ref1;
    var ref2 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useFormContext */ .Gc)(), register = ref2.register, _formState = ref2.formState, errors = _formState.errors, dirtyFields = _formState.dirtyFields;
    var errorMessage = dirtyFields[fieldName] && (errors === null || errors === void 0 ? void 0 : (ref = errors[fieldName]) === null || ref === void 0 ? void 0 : ref.message);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                type: "text",
                className: "join-input ".concat(!!errorMessage && "error-input"),
                placeholder: placeholder,
                autoComplete: "off"
            }, register(fieldName, {
                onChange: handleInputChange
            }), restProps)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "input-message ".concat(!!errorMessage && "error-message"),
                children: errorMessage
            }),
            dirtyFields[fieldName] && !(errors === null || errors === void 0 ? void 0 : (ref1 = errors[fieldName]) === null || ref1 === void 0 ? void 0 : ref1.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                className: "check-svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: "/static/images/signup/ic-check-blue.svg",
                    width: 14,
                    height: 10,
                    alt: "checked-interest"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InputText);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "InputText__StyledWrapper",
    componentId: "sc-bdcd055b-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), theme.line.line_2, theme.color.primary_2, theme.color.error_1, theme.color.error_1);
});


/***/ }),

/***/ 34754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var _app_feature_signup_signup_components_inputFields_InputText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97020);
/* harmony import */ var _app_feature_signup_signup_desktop_components_FormLabel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47393);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  gap: 9px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var FieldBirthday = function() {
    var handleBirthdayInput = function(e) {
        var inputText = e.target.value.trim().replace(/[^0-9]/g, "");
        e.target.value = inputText.slice(0, 8);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_signup_signup_desktop_components_FormLabel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                label: "생년월일"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_app_feature_signup_signup_components_inputFields_InputText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                fieldName: "birthday",
                placeholder: "YYYYMMDD",
                onInputChange: handleBirthdayInput,
                maxLength: 8
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FieldBirthday);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FieldBirthday__StyledWrapper",
    componentId: "sc-5121cc5d-0"
})(_templateObject());


/***/ }),

/***/ 11706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ signupInfo_FieldPhone; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.feature/signup/signup/desktop/components/FormLabel.tsx
var FormLabel = __webpack_require__(47393);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
;// CONCATENATED MODULE: ./src/app.feature/signup/signup/module/utils.ts
/**
 * @desc 0-9까지의 숫자만 입력받을 수 있도록 처리합니다
 */ var changeInputToOnlyNumber = function(e) {
    var inputText = e.target.value.trim().replace(/[^0-9]/g, "");
    e.target.value = inputText;
};

// EXTERNAL MODULE: ./src/constants/errorMessages.ts
var errorMessages = __webpack_require__(65155);
// EXTERNAL MODULE: ./src/hooks/useErrorSnackbar.ts
var useErrorSnackbar = __webpack_require__(96597);
// EXTERNAL MODULE: ./src/utils/apolloErrorParser.ts
var apolloErrorParser = __webpack_require__(29229);
// EXTERNAL MODULE: ./src/app.modules/hooks/useTimer.ts
var useTimer = __webpack_require__(62576);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInfo/FieldPhoneNumber/PhoneNumberButton.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 83px;\n    height: 50px;\n    border: none;\n    cursor: pointer;\n    padding: 13px 20px;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: bold;\n    letter-spacing: -0.64px;\n    color: white;\n    &[disabled] {\n      cursor: not-allowed;\n    }\n    &.inactive {\n      background-color: #bbb;\n    }\n    &.active {\n      background: ",
        ";\n    }\n    &.verified {\n      background-color: #bbb;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var PhoneNumberButton = function(_param) {
    var status = _param.status, buttonText = _param.buttonText, onClickButton = _param.onClickButton, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "status",
        "buttonText",
        "onClickButton"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        type: "button",
        className: "phone-button ".concat(status),
        onClick: onClickButton
    }, restProps), {
        children: buttonText
    }));
};
/* harmony default export */ var FieldPhoneNumber_PhoneNumberButton = (PhoneNumberButton);
var StyledWrapper = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    displayName: "PhoneNumberButton__StyledWrapper",
    componentId: "sc-e65ef9c1-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInfo/FieldPhoneNumber/FieldVerification.tsx



function FieldVerification_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    gap: 5px;\n    margin-top: 10px;\n    .verification-container {\n      flex: 1;\n      position: relative;\n      > .phone-input {\n        width: 100%;\n        height: 50px;\n        padding: 0 16px;\n        border-radius: 8px;\n        border: solid 1px ",
        ";\n        font-size: 16px;\n        &:focus {\n          outline: none;\n          border: solid 1px ",
        ";\n        }\n      }\n      > .timer {\n        position: absolute;\n        right: 14px;\n        top: 50%;\n        transform: translateY(-50%);\n        font-size: 16px;\n        letter-spacing: -0.64px;\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    FieldVerification_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FieldVerification_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    FieldVerification_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var FieldVerification = function(param) {
    var isVerified = param.isVerified, onClickVerify = param.onClickVerify, verificationToken = param.verificationToken;
    var ref = (0,index_esm/* useFormContext */.Gc)(), watch = ref.watch, register = ref.register, setError = ref.setError, setValue = ref.setValue, errors = ref.formState.errors;
    var enqueueApolloError = (0,useErrorSnackbar/* default */.Z)().enqueueApolloError;
    var inputPhone = watch("phoneInput") || "";
    var inputPhoneVerification = watch("phoneVerification") || "";
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCheckSmsAuthCodeMutation */.b5v)({
        onCompleted: function() {
            var _token;
            setValue("smsAuthedToken", (_token = data === null || data === void 0 ? void 0 : data.checkSmsAuthCode.token) !== null && _token !== void 0 ? _token : "");
            onClickVerify();
            handleClearTimer();
        },
        onError: function(err) {
            var errorCode = (0,apolloErrorParser/* getErrorCode */.zg)(err);
            if (errorCode) {
                setError("phoneVerification", {
                    message: errorMessages/* default */.Z[errorCode]
                });
            } else {
                enqueueApolloError();
            }
        }
    }), 2), checkSmsAuthCode = ref1[0], data = ref1[1].data;
    var THREE_MINUTES = 3 * 60;
    var ref2 = (0,useTimer/* default */.Z)(THREE_MINUTES), leftTime = ref2.leftTime, isExpire = ref2.isExpire, handleClearTimer = ref2.handleClearTimer, isCleared = ref2.isCleared;
    var query = (0,router.useRouter)().query;
    (0,react.useEffect)(function() {
        if (isExpire && !isCleared) {
            setError("phoneVerification", {
                message: "인증시간이 만료되었습니다. 다시 시도해주세요"
            });
        }
    }, [
        isExpire
    ]);
    var getButtonState = function() {
        var ref;
        if (isVerified) {
            return "verified";
        } else if (!isExpire && !((ref = errors.phoneVerification) === null || ref === void 0 ? void 0 : ref.message) && inputPhoneVerification.length === 6) {
            return "active";
        } else {
            return "inactive";
        }
    };
    var handleClickVerify = function() {
        checkSmsAuthCode({
            variables: {
                input: {
                    code: inputPhoneVerification,
                    token: verificationToken || query.token,
                    isSignupSession: query.token ? true : false,
                    phoneNumber: inputPhone
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FieldVerification_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "verification-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        type: "text",
                        maxLength: 6,
                        className: "phone-input ",
                        placeholder: "인증번호를 입력해주세요",
                        autoComplete: "off",
                        disabled: isVerified,
                        autoFocus: true
                    }, register("phoneVerification", {
                        onChange: changeInputToOnlyNumber
                    }))),
                    !isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "timer",
                        children: leftTime
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldPhoneNumber_PhoneNumberButton, {
                status: getButtonState(),
                disabled: isVerified || !!errors.phoneVerification || leftTime === "00:00",
                buttonText: "확인",
                onClickButton: handleClickVerify
            })
        ]
    });
};
/* harmony default export */ var FieldPhoneNumber_FieldVerification = (FieldVerification);
var FieldVerification_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FieldVerification__StyledWrapper",
    componentId: "sc-cf762103-0"
})(FieldVerification_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(FieldVerification_templateObject(), theme.line.line_2, theme.color.primary_2, theme.color.error_1);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInfo/FieldPhoneNumber/InputPhone.tsx





function InputPhone_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    .input-phone-container {\n      display: flex;\n      gap: 5px;\n      > .phone-input {\n        flex: 1;\n        width: 100%;\n        height: 50px;\n        padding: 0 16px;\n        border-radius: 8px;\n        border: solid 1px ",
        ";\n        font-size: 16px;\n        &:focus {\n          outline: none;\n          border: solid 1px ",
        ";\n        }\n      }\n    }\n\n    > span.input-message {\n      display: block;\n      height: 17px;\n      font-size: 12px;\n      font-weight: normal;\n      line-height: 17px;\n      letter-spacing: -0.48px;\n      &.error-message {\n        color: ",
        ";\n      }\n      &.verified-message {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    InputPhone_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InputPhone_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    InputPhone_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var InputPhone = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,index_esm/* useFormContext */.Gc)(), watch = ref4.watch, register = ref4.register, clearErrors = ref4.clearErrors, setValue = ref4.setValue, setError = ref4.setError, errors = ref4.formState.errors;
    var enqueueApolloError = (0,useErrorSnackbar/* default */.Z)().enqueueApolloError;
    var inputPhoneNumber = watch("phoneInput") || "";
    var ref5 = (0,react.useState)(false), isVerificationSent = ref5[0], setIsVerificationSent = ref5[1];
    var ref6 // FieldVerification 재호출에 사용하는 key값
     = (0,react.useState)(0), fieldVerificationField = ref6[0], setFieldVerificationKey = ref6[1];
    var ref7 = (0,react.useState)(false), isVerified = ref7[0], setIsVerified = ref7[1];
    var ref8 = (0,react.useState)(""), verificationToken = ref8[0], setVerificationToken = ref8[1];
    var query = (0,router.useRouter)().query;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGenerateSmsAuthCodeMutation */.ZDM)({
        onCompleted: function(data) {
            setVerificationToken(data.generateSmsAuthCode.token);
            setError("phoneVerification", {
                message: ""
            });
        },
        onError: function(err) {
            var errorCode = (0,apolloErrorParser/* getErrorCode */.zg)(err);
            if (errorCode) {
                setError("phoneInput", {
                    message: errorMessages/* default */.Z[errorCode]
                });
            } else {
                enqueueApolloError();
            }
        }
    }), 1), generateSmsAuthCode = ref9[0];
    var handlePhoneInput = function(e) {
        if (isVerificationSent) {
            setIsVerificationSent(false);
            clearErrors("phoneVerification");
        }
        changeInputToOnlyNumber(e);
    };
    var getButtonState = function() {
        if (isVerified) {
            return "verified";
        } else if (isVerificationSent || inputPhoneNumber.length >= 10) {
            return "active";
        } else {
            return "inactive";
        }
    };
    var handleClickSent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            generateSmsAuthCode({
                                variables: {
                                    input: {
                                        phoneNumber: inputPhoneNumber,
                                        token: query.token
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (!((ref = errors.phoneInput) === null || ref === void 0 ? void 0 : ref.message)) {
                            setIsVerificationSent(true);
                        }
                        setValue("phoneVerification", "");
                        setFieldVerificationKey(function(prev) {
                            return prev + 1;
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClickSent() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickVerify = function() {
        setValue("phoneNumber", inputPhoneNumber, {
            shouldValidate: true
        });
        setIsVerified(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputPhone_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "input-phone-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                        type: "text",
                        maxLength: 11,
                        className: "phone-input",
                        placeholder: "'-' 제외하고 입력",
                        autoComplete: "off",
                        disabled: isVerified
                    }, register("phoneInput", {
                        onChange: handlePhoneInput
                    }))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldPhoneNumber_PhoneNumberButton, {
                        status: getButtonState(),
                        disabled: inputPhoneNumber.length < 10 || isVerified,
                        buttonText: isVerificationSent ? "재발송" : "인증하기",
                        onClickButton: handleClickSent
                    })
                ]
            }),
            isVerificationSent && /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldPhoneNumber_FieldVerification, {
                onClickVerify: handleClickVerify,
                isVerified: isVerified,
                verificationToken: verificationToken
            }, fieldVerificationField),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "input-message ".concat(((ref = errors.phoneInput) === null || ref === void 0 ? void 0 : ref.message) || ((ref1 = errors.phoneVerification) === null || ref1 === void 0 ? void 0 : ref1.message) ? "error-message" : isVerified && "verified-message"),
                children: [
                    ((ref2 = errors.phoneInput) === null || ref2 === void 0 ? void 0 : ref2.message) || ((ref3 = errors.phoneVerification) === null || ref3 === void 0 ? void 0 : ref3.message),
                    isVerified && "인증이 완료되었습니다"
                ]
            })
        ]
    });
};
/* harmony default export */ var FieldPhoneNumber_InputPhone = (InputPhone);
var InputPhone_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputPhone__StyledWrapper",
    componentId: "sc-a5783736-0"
})(InputPhone_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(InputPhone_templateObject(), theme.line.line_2, theme.color.primary_2, theme.color.error_1, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInfo/FieldPhone.tsx

function FieldPhone_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    gap: 9px;\n    > .entered-phone {\n      display: flex;\n      align-items: center;\n      height: 50px;\n      padding: 0 16px;\n      border-radius: 8px;\n      border: solid 1px ",
        ";\n      font-size: 16px;\n      background: ",
        ";\n      margin-bottom: 17px;\n    }\n  "
    ]);
    FieldPhone_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FieldPhone_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    FieldPhone_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var FieldPhone = function(param) {
    var _isRequired = param.isRequired, isRequired = _isRequired === void 0 ? true : _isRequired, subTitle = param.subTitle;
    var query = (0,router.useRouter)().query;
    var watch = (0,index_esm/* useFormContext */.Gc)().watch;
    var userPhoneNumber = query.phoneNumber ? query.phoneNumber.replace(/[^0-9]/g, "") : watch("phoneNumber");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FieldPhone_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormLabel/* default */.Z, {
                label: "휴대폰번호",
                isRequired: isRequired,
                subTitle: subTitle
            }),
            userPhoneNumber ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "entered-phone",
                children: userPhoneNumber
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FieldPhoneNumber_InputPhone, {})
        ]
    });
};
/* harmony default export */ var signupInfo_FieldPhone = (FieldPhone);
var FieldPhone_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FieldPhone__StyledWrapper",
    componentId: "sc-6097227f-0"
})(FieldPhone_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(FieldPhone_templateObject(), theme.line.line_2, theme.background.bg_3);
});


/***/ }),

/***/ 33400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ signupInfo_FieldSchool; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(55999);
// EXTERNAL MODULE: ./src/hooks/useOutSideClick.ts
var useOutSideClick = __webpack_require__(19468);
// EXTERNAL MODULE: ./src/svgIcons/MagnifyingGlass.tsx
var MagnifyingGlass = __webpack_require__(8741);
;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/inputFields/searchKeyword/components/InputKeyword.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    & > input {\n      width: 100%;\n      height: 50px;\n      border-radius: 8px;\n      border: solid 1px ",
        ";\n      background-color: ",
        ";\n      font-size: 16px;\n      font-weight: 500;\n      line-height: 48px;\n      letter-spacing: -0.64px;\n      text-align: left;\n      color: ",
        ";\n      padding: 13px 35px 13px 15px;\n\n      &:focus {\n        border: 1px solid ",
        ";\n        outline: none;\n      }\n      &.error {\n        color: ",
        ";\n        border: solid 1px ",
        ";\n      }\n      &::placeholder {\n        color: ",
        ";\n      }\n    }\n\n    & > .icon-postcode-search {\n      width: 16px;\n      height: 16px;\n      position: absolute;\n      top: 17px;\n      right: 13px;\n    }\n\n    & > .error-message {\n      height: 17px;\n      font-size: 12px;\n      font-weight: normal;\n      line-height: 17px;\n      letter-spacing: -0.48px;\n      text-align: left;\n      color: ",
        ";\n      margin-top: 10px;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InputKeyword = /*#__PURE__*/ (0,react.forwardRef)(function(_param, searchKeywordRef) {
    var errorMessage = _param.errorMessage, onChangeKeyword = _param.onChangeKeyword, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "errorMessage",
        "onChangeKeyword"
    ]);
    var onChange = restProps.onChange, restInputProps = (0,_object_without_properties/* default */.Z)(restProps, [
        "onChange"
    ]);
    var handleChange = function(e) {
        var value = e.target.value.trim();
        e.target.value = value;
        onChangeKeyword(value);
        if (onChange) {
            onChange(e);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                type: "text",
                className: errorMessage ? "error" : "",
                ref: searchKeywordRef,
                onChange: handleChange,
                autoComplete: "off"
            }, restInputProps)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MagnifyingGlass/* default */.Z, {
                className: "icon-postcode-search"
            }),
            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "error-message",
                children: errorMessage
            })
        ]
    });
});
/* harmony default export */ var components_InputKeyword = (InputKeyword);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputKeyword__StyledWrapper",
    componentId: "sc-34092fdc-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.line.line_2, theme.background.bg_8, theme.color.text_1, theme.color.primary_2, theme.color.error_1, theme.color.error_1, theme.color.text_3, theme.color.error_1);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/inputFields/searchKeyword/keywordList/components/EmptyListItem.tsx

function EmptyListItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    display: flex;\n    align-items: center;\n    padding: 15px 10px;\n\n    & > span {\n      width: 100%;\n      height: 20px;\n      padding-left: 13px;\n      font-size: 14px;\n      font-weight: normal;\n      line-height: 20px;\n      letter-spacing: -0.56px;\n      text-align: left;\n      color: ",
        ";\n    }\n  "
    ]);
    EmptyListItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EmptyListItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    EmptyListItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var EmptyListItem = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyListItem_StyledWrapper, {
        "aria-describedby": "검색 결과가 존재하지 않습니다.",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: "일치하는 조건이 없습니다."
        })
    });
};
/* harmony default export */ var components_EmptyListItem = (EmptyListItem);
var EmptyListItem_StyledWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "EmptyListItem__StyledWrapper",
    componentId: "sc-de8dc378-0"
})(EmptyListItem_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(EmptyListItem_templateObject(), theme.color.text_1);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/inputFields/searchKeyword/keywordList/components/KeywordListItem.tsx

function KeywordListItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    display: flex;\n    align-items: center;\n    padding: 15px 0;\n    cursor: pointer;\n\n    &:hover {\n      background-color: ",
        ";\n    }\n\n    & > p {\n      width: 100%;\n      height: 20px;\n      padding-left: 13px;\n      font-size: 14px;\n      font-weight: normal;\n      line-height: 20px;\n      letter-spacing: -0.56px;\n      text-align: left;\n      color: ",
        ";\n    }\n  "
    ]);
    KeywordListItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function KeywordListItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    KeywordListItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var KeywordListItem = function(param) {
    var dataId = param.dataId, itemName = param.itemName, onClickItem = param.onClickItem;
    var handleClick = function(e) {
        var selectName = e.currentTarget.dataset.selectName || "";
        var selectId = e.currentTarget.dataset.selectId || "";
        onClickItem({
            id: selectId,
            name: selectName
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordListItem_StyledWrapper, {
        onClick: handleClick,
        "data-select-name": itemName,
        "data-select-id": dataId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: itemName
        })
    });
};
/* harmony default export */ var components_KeywordListItem = (KeywordListItem);
var KeywordListItem_StyledWrapper = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    displayName: "KeywordListItem__StyledWrapper",
    componentId: "sc-1bf506f6-0"
})(KeywordListItem_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(KeywordListItem_templateObject(), theme.background.bg_3, theme.color.text_1);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/inputFields/searchKeyword/keywordList/components/SelectLiteralButton.tsx

function SelectLiteralButton_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    min-height: 47px;\n    border-top: solid 1px ",
        ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    button {\n      width: 100%;\n      min-height: 20px;\n      border: 0;\n      background-color: transparent;\n      font-size: 14px;\n      font-weight: normal;\n      line-height: 20px;\n      letter-spacing: -0.56px;\n      text-align: center;\n      color: ",
        ";\n      text-decoration: underline;\n      cursor: pointer;\n      display: block;\n      overflow-wrap: break-word;\n    }\n  "
    ]);
    SelectLiteralButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectLiteralButton_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SelectLiteralButton_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SelectLiteralButton = function(param) {
    var keyword = param.keyword, onClick = param.onClick;
    var handleClick = function() {
        onClick({
            name: keyword
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectLiteralButton_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            className: "button-input-value",
            onClick: handleClick,
            type: "button",
            children: [
                keyword,
                " 직접입력"
            ]
        })
    });
};
/* harmony default export */ var components_SelectLiteralButton = (SelectLiteralButton);
var SelectLiteralButton_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectLiteralButton__StyledWrapper",
    componentId: "sc-e6d0732c-0"
})(SelectLiteralButton_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(SelectLiteralButton_templateObject(), theme.line.line_1, theme.color.primary_2);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/inputFields/searchKeyword/keywordList/KeywordList.tsx

function KeywordList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    position: absolute;\n    top: 54px;\n    z-index: 30;\n    background-color: ",
        ";\n    border-radius: 8px;\n    border: solid 1px ",
        ";\n\n    & > ul {\n      min-height: 130px;\n      max-height: 230px;\n      padding-top: 8px;\n      overflow-y: auto;\n    }\n  "
    ]);
    KeywordList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function KeywordList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    KeywordList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var KeywordList = function(param) {
    var _keywordListData = param.keywordListData, keywordListData = _keywordListData === void 0 ? [] : _keywordListData, keyword = param.keyword, onSelectKeywordItem = param.onSelectKeywordItem;
    var handleSelectItem = function(keyword) {
        onSelectKeywordItem(keyword);
    };
    var isListEmpty = keywordListData.length === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(KeywordList_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    isListEmpty && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EmptyListItem, {}),
                    keywordListData.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_KeywordListItem, {
                            itemName: item.name,
                            dataId: item.id,
                            onClickItem: handleSelectItem
                        }, "search-keyword-key-".concat(item.id));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SelectLiteralButton, {
                keyword: keyword,
                onClick: handleSelectItem
            })
        ]
    });
};
/* harmony default export */ var keywordList_KeywordList = (KeywordList);
var KeywordList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "KeywordList__StyledWrapper",
    componentId: "sc-4340ab59-0"
})(KeywordList_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(KeywordList_templateObject(), theme.background.bg_8, theme.line.line_1);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/inputFields/searchKeyword/InputSearchKeyword.tsx



function InputSearchKeyword_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  position: relative;\n"
    ]);
    InputSearchKeyword_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var InputSearchKeyword = /*#__PURE__*/ (0,react.forwardRef)(function(_param, searchKeywordRef) {
    var keywordList = _param.keywordList, onSelectKeywordOption = _param.onSelectKeywordOption, onKeywordQuery = _param.onKeywordQuery, restInputProps = (0,_object_without_properties/* default */.Z)(_param, [
        "keywordList",
        "onSelectKeywordOption",
        "onKeywordQuery"
    ]);
    var outSideWrapperRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isShowInputSearch = ref[0], setIsShowInputSearch = ref[1];
    var ref1 = (0,react.useState)(""), literalKeyword = ref1[0], setLiteralKeyword = ref1[1];
    var debouncedCallback = (0,useDebounce/* useDebounce */.N)(function(keyword) {
        setLiteralKeyword(function() {
            return keyword;
        });
        onKeywordQuery(keyword);
    }, 300);
    var handleChangeKeyword = function(value) {
        setIsShowInputSearch(!!value);
        debouncedCallback(value);
    };
    var handleSelectKeywordItem = function(selectValue) {
        if (onSelectKeywordOption) {
            onSelectKeywordOption(selectValue);
            setIsShowInputSearch(false);
        }
    };
    var handleOutsideClick = function() {
        setIsShowInputSearch(false);
    };
    (0,useOutSideClick/* useOutSideClick */.A)({
        ref: outSideWrapperRef,
        isActive: isShowInputSearch,
        onOutsideClick: handleOutsideClick
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputSearchKeyword_StyledWrapper, {
        ref: outSideWrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_InputKeyword, (0,_object_spread/* default */.Z)({
                onChangeKeyword: handleChangeKeyword,
                ref: searchKeywordRef
            }, restInputProps)),
            isShowInputSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(keywordList_KeywordList, {
                keyword: literalKeyword,
                keywordListData: keywordList || [],
                onSelectKeywordItem: handleSelectKeywordItem
            })
        ]
    });
});
/* harmony default export */ var searchKeyword_InputSearchKeyword = (InputSearchKeyword);
var InputSearchKeyword_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputSearchKeyword__StyledWrapper",
    componentId: "sc-83e38e6-0"
})(InputSearchKeyword_templateObject());

// EXTERNAL MODULE: ./src/svgIcons/ExpandMore.tsx
var ExpandMore = __webpack_require__(40934);
;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/inputFields/select/SelectBox.tsx

function SelectBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: 50px;\n    padding: 0 16px;\n    border-radius: 8px;\n    border: solid 1px ",
        ";\n    font-size: 15px;\n    display: flex;\n    align-items: center;\n    > p {\n      flex: 1;\n      letter-spacing: -0.64px;\n      text-align: left;\n      &[aria-describedby='placeholder'] {\n        color: ",
        ";\n      }\n    }\n  "
    ]);
    SelectBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SelectBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SelectBox = function(param) {
    var handleClick = param.onClick, selectedValue = param.selectedValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectBox_StyledWrapper, {
        onClick: handleClick,
        children: [
            selectedValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: selectedValue
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                "aria-describedby": "placeholder",
                children: "선택"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                className: "icon-arrow",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {})
            })
        ]
    });
};
/* harmony default export */ var select_SelectBox = (SelectBox);
var SelectBox_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SelectBox__StyledWrapper",
    componentId: "sc-73c0922c-0"
})(SelectBox_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(SelectBox_templateObject(), theme.line.line_2, theme.color.text_2);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/inputFields/select/SelectDropdown.tsx

function SelectDropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    height: fit-content;\n    max-height: 320px;\n    overflow-y: auto;\n    border: solid 1px ",
        ";\n    border-radius: 8px;\n    background-color: ",
        ";\n    position: absolute;\n    left: 0;\n    top: 54px;\n    z-index: 10;\n\n    & > li {\n      height: 40px;\n      display: flex;\n      align-items: center;\n      padding: 10px 15px;\n\n      &:hover {\n        background-color: ",
        ";\n      }\n\n      p {\n        height: 20px;\n        font-size: 14px;\n        font-weight: normal;\n        line-height: 20px;\n        letter-spacing: -0.56px;\n        text-align: left;\n        color: ",
        ";\n\n        &:not(:first-child) {\n          margin-left: 5px;\n        }\n      }\n    }\n  "
    ]);
    SelectDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SelectDropdown_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SelectDropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SelectDropdown = function(param) {
    var options = param.options, onClickOption = param.onClickOption;
    var handleClickOption = function(e) {
        onClickOption(e.currentTarget.dataset.selectValue || "");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown_StyledWrapper, {
        children: options.map(function(option) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                "data-select-value": option.value,
                onClick: handleClickOption,
                children: option.label
            }, option.value);
        })
    });
};
/* harmony default export */ var select_SelectDropdown = (SelectDropdown);
var SelectDropdown_StyledWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    displayName: "SelectDropdown__StyledWrapper",
    componentId: "sc-d6dc51b9-0"
})(SelectDropdown_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(SelectDropdown_templateObject(), theme.line.line_1, theme.background.bg_8, theme.background.bg_3, theme.color.text_1);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/constant/schoolTypeConstant.ts

var SCHOOL_TYPES = [
    {
        label: "고등학교",
        value: graphql/* UserEducation.HIGH_SCHOOL_GRADUATE */.I05.HIGH_SCHOOL_GRADUATE
    },
    {
        label: "대학교(2,3년)",
        value: graphql/* UserEducation.COLLEGE_GRADUATE_2_3_YEARS */.I05.COLLEGE_GRADUATE_2_3_YEARS
    },
    {
        label: "대학교(4년)",
        value: graphql/* UserEducation.COLLEGE_GRADUATE_4_YEARS */.I05.COLLEGE_GRADUATE_4_YEARS
    },
    {
        label: "대학원",
        value: graphql/* UserEducation.MASTER_GRADUATE */.I05.MASTER_GRADUATE
    }, 
];

// EXTERNAL MODULE: ./src/app.feature/signup/signup/desktop/components/FormLabel.tsx
var FormLabel = __webpack_require__(47393);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/use-debounce/esm/useDebouncedCallback.js
var useDebouncedCallback = __webpack_require__(19302);
;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/inputFields/searchMajor/InputSearchMajor.tsx






function InputSearchMajor_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    > .input-major-wrapper {\n      position: relative;\n      > .input-major {\n        width: 100%;\n        height: 50px;\n        padding: 0 16px;\n        border-radius: 8px;\n        border: solid 1px #dddddd;\n        font-size: 16px;\n        &:focus {\n          border: 1px solid ",
        ";\n          outline: none;\n        }\n        &.error {\n          color: ",
        ";\n          border: solid 1px ",
        ";\n        }\n        &::placeholder {\n          color: ",
        ";\n        }\n      }\n    }\n  "
    ]);
    InputSearchMajor_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InputSearchMajor_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    InputSearchMajor_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var InputSearchMajor = function() {
    var ref = (0,index_esm/* useFormContext */.Gc)(), register = ref.register, setValue = ref.setValue;
    var outSideWrapperRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), isShowInputSearch = ref1[0], setIsShowInputSearch = ref1[1];
    var ref2 = (0,react.useState)(""), majorInput = ref2[0], setMajorInput = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlSearchMajorsLazyQuery */.WqL)(), 2), searchMajorList = ref3[0], data = ref3[1].data;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlMajorByNameLazyQuery */.ueB)(), 1), createMajorName = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useDebouncedCallback/* default */.Z)(function(keyword) {
        setMajorInput(keyword);
        handleKeywordQuery && handleKeywordQuery(keyword);
    }, 300), 1), debouncedCallback = ref5[0];
    var handleChangeKeyword = function(value) {
        setIsShowInputSearch(!!value);
        debouncedCallback(value);
    };
    var handleChangeMajorInput = function(e) {
        var value = e.target.value.trim();
        e.target.value = value;
        handleChangeKeyword(value);
    };
    var handleSelectKeywordOption = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(selectOptionValue) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!selectOptionValue.id) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            createMajorName({
                                variables: {
                                    name: selectOptionValue.name
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        setValue("schoolMajor", {
                            id: (data === null || data === void 0 ? void 0 : data.majorByName.id) || "",
                            name: (data === null || data === void 0 ? void 0 : data.majorByName.name) || ""
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setValue("schoolMajor", {
                            id: selectOptionValue.id || "",
                            name: selectOptionValue.name
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectKeywordOption(selectOptionValue) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSelectKeywordItem = function(selectValue) {
        handleSelectKeywordOption(selectValue);
        setIsShowInputSearch(false);
    };
    var handleOutsideClick = function() {
        setIsShowInputSearch(false);
    };
    (0,useOutSideClick/* useOutSideClick */.A)({
        ref: outSideWrapperRef,
        isActive: isShowInputSearch,
        onOutsideClick: handleOutsideClick
    });
    var handleKeywordQuery = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(keyword) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!keyword) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            searchMajorList({
                                variables: {
                                    filterBy: {
                                        query: keyword
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleKeywordQuery(keyword) {
            return _ref.apply(this, arguments);
        };
    }();
    var majorList = data === null || data === void 0 ? void 0 : data.searchMajors.map(function(item) {
        return {
            id: item.id,
            name: item.name
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputSearchMajor_StyledWrapper, {
        ref: outSideWrapperRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "input-major-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    type: "text",
                    placeholder: "전공",
                    autoComplete: "off",
                    className: "input-major"
                }, register("schoolMajor.name")), {
                    onChange: handleChangeMajorInput
                }))
            }),
            isShowInputSearch && /*#__PURE__*/ (0,jsx_runtime.jsx)(keywordList_KeywordList, {
                keyword: majorInput,
                keywordListData: majorList || [],
                onSelectKeywordItem: handleSelectKeywordItem
            })
        ]
    });
};
/* harmony default export */ var searchMajor_InputSearchMajor = (InputSearchMajor);
var InputSearchMajor_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "InputSearchMajor__StyledWrapper",
    componentId: "sc-35268ed4-0"
})(InputSearchMajor_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(InputSearchMajor_templateObject(), theme.color.primary_2, theme.color.error_1, theme.color.error_1, theme.color.text_3);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInfo/FieldSchool.tsx





function FieldSchool_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: grid;\n    gap: 9px;\n    .field-school-container {\n      display: grid;\n      grid-template-columns: ",
        ";\n      gap: ",
        ";\n      .selectBox-container {\n        position: relative;\n        cursor: pointer;\n      }\n    }\n    p {\n      margin: 0 !important;\n    }\n    ul {\n      margin: 0;\n    }\n  "
    ]);
    FieldSchool_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FieldSchool_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    FieldSchool_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var FieldSchool = function() {
    var ref;
    var ref1 = (0,index_esm/* useFormContext */.Gc)(), register = ref1.register, setValue = ref1.setValue;
    var selectRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), isOpenSelect = ref2[0], setIsOpenSelect = ref2[1];
    var handleSelectBoxOpen = function() {
        setIsOpenSelect(!isOpenSelect);
    };
    var handleOutsideClick = function() {
        setIsOpenSelect(false);
    };
    (0,useOutSideClick/* useOutSideClick */.A)({
        ref: selectRef,
        isActive: isOpenSelect,
        onOutsideClick: handleOutsideClick
    });
    var getHighUniType = function(selectedType) {
        return selectedType === graphql/* UserEducation.HIGH_SCHOOL_GRADUATE */.I05.HIGH_SCHOOL_GRADUATE ? graphql/* SchoolType.HIGH_SCHOOL */.ZYF.HIGH_SCHOOL : graphql/* SchoolType.UNIVERSITY */.ZYF.UNIVERSITY;
    };
    var selectedSchoolType = (0,index_esm/* useWatch */.qo)({
        name: "schoolType"
    });
    var selectedHighUnivType = getHighUniType(selectedSchoolType);
    var handleSelectSchoolType = function(selectedType) {
        var newSelectedHighUnivType = getHighUniType(selectedType);
        if (newSelectedHighUnivType !== selectedHighUnivType) {
            setValue("school", {
                id: "",
                name: "",
                isChanged: false
            }, {
                shouldValidate: true
            });
            setValue("schoolMajor", {
                id: "",
                name: ""
            });
        }
        setValue("schoolType", selectedType, {
            shouldValidate: true
        });
        setIsOpenSelect(false);
    };
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlSearchSchoolsLazyQuery */.hVB)(), 2), searchSchoolName = ref3[0], ref4 = ref3[1], schoolList = ref4.data;
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useGqlSchoolByNameLazyQuery */._t1)(), 1), schoolByName = ref5[0];
    var handleSelectKeywordOption = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(selectOptionValue) {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!selectOptionValue.id) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            schoolByName({
                                variables: {
                                    type: selectedHighUnivType,
                                    name: selectOptionValue.name
                                }
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        setValue("school", {
                            id: (data === null || data === void 0 ? void 0 : data.schoolByName.id) || "",
                            name: (data === null || data === void 0 ? void 0 : data.schoolByName.name) || "",
                            isChanged: false
                        }, {
                            shouldValidate: true
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setValue("school", {
                            id: selectOptionValue.id || "",
                            name: selectOptionValue.name,
                            isChanged: false
                        }, {
                            shouldValidate: true
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectKeywordOption(selectOptionValue) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleKeywordQuery = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(keyword) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!keyword) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            searchSchoolName({
                                variables: {
                                    filterBy: {
                                        type: selectedHighUnivType,
                                        query: keyword
                                    }
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleKeywordQuery(keyword) {
            return _ref.apply(this, arguments);
        };
    }();
    var selectSchoolTypeLabel = ((ref = SCHOOL_TYPES.find(function(option) {
        return option.value === selectedSchoolType;
    })) === null || ref === void 0 ? void 0 : ref.label) || "";
    var keywordList = schoolList === null || schoolList === void 0 ? void 0 : schoolList.searchSchools.map(function(school) {
        return {
            id: school.id,
            name: school.name
        };
    });
    var handleChangeEditState = function() {
        setValue("school.isChanged", true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FieldSchool_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormLabel/* default */.Z, {
                label: "최종학력"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "field-school-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "selectBox-container",
                        ref: selectRef,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(select_SelectBox, {
                                onClick: handleSelectBoxOpen,
                                selectedValue: selectSchoolTypeLabel
                            }),
                            isOpenSelect && /*#__PURE__*/ (0,jsx_runtime.jsx)(select_SelectDropdown, {
                                options: SCHOOL_TYPES,
                                onClickOption: handleSelectSchoolType
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(searchKeyword_InputSearchKeyword, (0,_object_spread/* default */.Z)({
                        placeholder: "학교명",
                        keywordList: keywordList,
                        onSelectKeywordOption: handleSelectKeywordOption,
                        onKeywordQuery: handleKeywordQuery
                    }, register("school.name", {
                        onChange: handleChangeEditState
                    })))
                ]
            }),
            selectedSchoolType && selectedSchoolType !== graphql/* UserEducation.HIGH_SCHOOL_GRADUATE */.I05.HIGH_SCHOOL_GRADUATE && /*#__PURE__*/ (0,jsx_runtime.jsx)(searchMajor_InputSearchMajor, {})
        ]
    });
};
/* harmony default export */ var signupInfo_FieldSchool = (FieldSchool);
var FieldSchool_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "FieldSchool__StyledWrapper",
    componentId: "sc-2908b47d-0"
})(FieldSchool_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(FieldSchool_templateObject(), !theme.isMobile && "160px auto", theme.isMobile ? "10px" : "5px");
});


/***/ }),

/***/ 53043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ signupInterest_SignupInterest; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.feature/signup/signup/desktop/components/FormLabel.tsx
var FormLabel = __webpack_require__(47393);
// EXTERNAL MODULE: ./src/constants/enums.ts
var enums = __webpack_require__(35460);
// EXTERNAL MODULE: ./src/constants/typeText.ts
var typeText = __webpack_require__(25536);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInterest/interestActivity/components/ActivityContainer.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    label {\n      width: 100%;\n      flex: 1;\n      position: relative;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 8px;\n      border: solid 1px ",
        ";\n      margin-bottom: 10px;\n    }\n    .check-svg {\n      position: absolute;\n      top: -1px;\n      right: -1px;\n      width: 22px;\n      height: 22px;\n      border-radius: 0 8px 0 8px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    > input {\n      display: none;\n      &:checked + label {\n        background-color: ",
        ";\n        border: 1px solid ",
        ";\n        > .check-svg {\n          display: flex;\n          background-color: ",
        ";\n        }\n      }\n    }\n    > p {\n      font-family: NotoSansKR;\n      font-size: 14px;\n      letter-spacing: -0.7px;\n      text-align: center;\n      color: #333;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ActivityContainer = function(param) {
    var name = param.name, checked = param.checked;
    var register = (0,index_esm/* useFormContext */.Gc)().register;
    var id = typeText/* ACTIVITY_TYPE_TEXT_ID */.RO[name];
    var labelName = typeText/* ACTIVITY_TYPE_TEXT */.DK[id];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                type: "checkbox",
                id: "activity-".concat(name),
                value: id,
                checked: checked
            }, register("preferActivityTypes"))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: "activity-".concat(name),
                className: "pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/static/images/signup/interest-group-".concat(name, ".svg"),
                        width: 40,
                        height: 40,
                        alt: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "check-svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/static/images/signup/ic-check-white.svg",
                            width: 12,
                            height: 9,
                            alt: "checked-interest"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: labelName
            })
        ]
    });
};
/* harmony default export */ var components_ActivityContainer = (ActivityContainer);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ActivityContainer__StyledWrapper",
    componentId: "sc-3c7b46bd-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), theme.line.line_2, theme.background.bg_4, theme.color.primary_2, theme.color.primary_2);
});

// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInterest/interestActivity/components/CompanyContainer.tsx


function CompanyContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    display: inline-block;\n    flex-direction: row;\n    justify-content: center;\n    margin: 0 4px 8px 0;\n    > input {\n      display: none;\n      &:checked + label {\n        color: ",
        ";\n        border: solid 1px ",
        ";\n        background-color: ",
        ";\n        > .check-svg {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 20px;\n        }\n      }\n    }\n    > label {\n      display: flex;\n      align-items: center;\n      height: 40px;\n      padding: 10px 15px;\n      border-radius: 8px;\n      border: solid 1px ",
        ";\n      > p {\n        height: 20px;\n        font-size: 14px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        letter-spacing: -0.56px;\n      }\n      > .check-svg {\n        display: none;\n      }\n    }\n  "
    ]);
    CompanyContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompanyContainer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    CompanyContainer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var CompanyContainer = function(param) {
    var company = param.company;
    var register = (0,index_esm/* useFormContext */.Gc)().register;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyContainer_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                type: "checkbox",
                id: "company-".concat(company.name),
                value: company.id
            }, register("preferOrganizationIds"))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: "company-".concat(company.name),
                className: "pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: company.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "check-svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Check */.Jr, {
                            className: "check-icon",
                            color: "#01a0ff",
                            width: 12
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CompanyContainer = (CompanyContainer);
var CompanyContainer_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "CompanyContainer__StyledWrapper",
    componentId: "sc-476c353e-0"
})(CompanyContainer_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(CompanyContainer_templateObject(), theme.color.primary_2, theme.color.primary_2, theme.background.bg_4, theme.line.line_2);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInterest/interestActivity/FieldActivity.tsx

function FieldActivity_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: grid;\n  gap: 16px;\n  .field-activity-container {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    height: 102px;\n    gap: 10px;\n  }\n"
    ]);
    FieldActivity_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var FieldActivity = function() {
    var ref = (0,index_esm/* useFormContext */.Gc)(), watch = ref.watch, resetField = ref.resetField;
    var ref1 = (0,graphql/* useGqlPreferredOrganizationsQuery */.sVd)(), data = ref1.data, loading = ref1.loading, error = ref1.error;
    var activites = [
        "recruit",
        "activity",
        "contest",
        "education"
    ];
    var isRecruitChecked = (watch("preferActivityTypes") || []).map(Number).includes(enums/* ActivityTypeID.RECRUIT */.kF.RECRUIT);
    var selectedPreferActivityTypes = (0,index_esm/* useWatch */.qo)({
        name: "preferActivityTypes"
    }) || [];
    (0,react.useEffect)(function() {
        if (!isRecruitChecked) {
            resetField("preferOrganizationIds", {
                defaultValue: []
            });
        }
    }, [
        isRecruitChecked
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FieldActivity_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormLabel/* default */.Z, {
                label: "관심 분야",
                canMultiple: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "field-activity-container",
                children: activites.map(function(name, index) {
                    var id = String(typeText/* ACTIVITY_TYPE_TEXT_ID */.RO[name]);
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ActivityContainer, {
                        name: name,
                        checked: (selectedPreferActivityTypes === null || selectedPreferActivityTypes === void 0 ? void 0 : selectedPreferActivityTypes.includes(id)) || false
                    }, index);
                })
            }),
            isRecruitChecked && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormLabel/* default */.Z, {
                        label: "관심 기업",
                        canMultiple: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: data && !loading && !error && data.preferredOrganizations.map(function(company) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompanyContainer, {
                                company: company
                            }, company.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var interestActivity_FieldActivity = (FieldActivity);
var FieldActivity_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "FieldActivity__StyledWrapper",
    componentId: "sc-ce7baec5-0"
})(FieldActivity_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInterest/interestJob/components/JobBlock.tsx


function JobBlock_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 40px;\n    display: inline-block;\n    flex-direction: row;\n    justify-content: center;\n    margin: 0 4px 8px 0;\n    > input {\n      display: none;\n      &:checked + label {\n        color: ",
        ";\n        border: solid 1px ",
        ";\n        background-color: ",
        ";\n        > .check-svg {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          width: 20px;\n        }\n      }\n    }\n    > label {\n      display: flex;\n      align-items: center;\n      height: 40px;\n      padding: 10px 15px;\n      border-radius: 8px;\n      border: solid 1px ",
        ";\n      > p {\n        height: 20px;\n        font-size: 14px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        letter-spacing: -0.56px;\n      }\n      > .check-svg {\n        display: none;\n      }\n    }\n  "
    ]);
    JobBlock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function JobBlock_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    JobBlock_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var JobBlock = function(param) {
    var item = param.item;
    var register = (0,index_esm/* useFormContext */.Gc)().register;
    var id = item.id, name = item.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobBlock_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                type: "checkbox",
                id: "job-".concat(name),
                value: id
            }, register("preferJobCategoryIds"))),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: "job-".concat(name),
                className: "pointer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "check-svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* Check */.Jr, {
                            className: "check-icon",
                            color: "#01a0ff",
                            width: 12
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_JobBlock = (JobBlock);
var JobBlock_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "JobBlock__StyledWrapper",
    componentId: "sc-42eda1f2-0"
})(JobBlock_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components_browser_esm/* css */.iv)(JobBlock_templateObject(), theme.color.primary_2, theme.color.primary_2, theme.background.bg_4, theme.line.line_2);
});

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInterest/interestJob/FieldJob.tsx

function FieldJob_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: grid;\n  gap: 16px;\n"
    ]);
    FieldJob_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var FieldJob = function() {
    var ref = (0,graphql/* useGqlJobCategoriesQuery */.IEp)(), data = ref.data, loading = ref.loading, error = ref.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FieldJob_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormLabel/* default */.Z, {
                label: "관심 직무",
                canMultiple: true
            }),
            !(loading || error) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: data === null || data === void 0 ? void 0 : data.jobCategories.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_JobBlock, {
                        item: item
                    }, item.id);
                })
            })
        ]
    });
};
/* harmony default export */ var interestJob_FieldJob = (FieldJob);
var FieldJob_StyledWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    displayName: "FieldJob__StyledWrapper",
    componentId: "sc-31fd2c9d-0"
})(FieldJob_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/signup/signup/components/signupInterest/SignupInterest.tsx

function SignupInterest_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  margin-top: 28px;\n  gap: 28px;\n"
    ]);
    SignupInterest_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var SignupInterest = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SignupInterest_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(interestActivity_FieldActivity, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(interestJob_FieldJob, {})
        ]
    });
};
/* harmony default export */ var signupInterest_SignupInterest = (SignupInterest);
var SignupInterest_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "SignupInterest__StyledWrapper",
    componentId: "sc-ca3969d8-0"
})(SignupInterest_templateObject());


/***/ }),

/***/ 47393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30132);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    gap: 4px;\n    > p {\n      font-size: 13px;\n      font-weight: normal;\n      font-stretch: normal;\n      font-style: normal;\n      letter-spacing: -0.52px;\n      color: #333;\n      span {\n        color: ",
        ";\n      }\n      &.required::after {\n        content: '*';\n        color: ",
        ";\n        padding-left: 4px;\n      }\n    }\n    > .sub-title {\n      font-size: 12px;\n      letter-spacing: -0.48px;\n      color: ",
        ";\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var FormLabel = function(param) {
    var label = param.label, canMultiple = param.canMultiple, subTitle = param.subTitle, _isRequired = param.isRequired, isRequired = _isRequired === void 0 ? true : _isRequired;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                className: isRequired ? "required" : "",
                children: [
                    label,
                    canMultiple && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        children: "\xa0(중복 선택 가능)"
                    })
                ]
            }),
            subTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                className: "sub-title",
                children: subTitle
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormLabel);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormLabel__StyledWrapper",
    componentId: "sc-3a82a00d-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), theme.color.text_2, theme.color.error_1, theme.color.text_2);
});


/***/ }),

/***/ 62576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * TODO : 추후 추상화하여 모듈화 하기
 * @desc 이메인 인증 코드의 입력 시간 타이머를 적용합니다
 * @desc time ex) 60분 = 60 * 60, 59분 59초 = 60 * 59 + 59
 * @param time 타이머 시작 시간
 * @returns
 */ var useTimer = function(time) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(time), timeLeft = ref[0], setTimeLeft = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isExpire = ref1[0], setIsExpire = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isCleared = ref2[0], setIsCleared = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isCleared) {
            return;
        }
        var interval = setInterval(function() {
            setTimeLeft(function(prevTime) {
                return prevTime - 1;
            });
        }, 1000);
        if (timeLeft < 1) {
            clearInterval(interval);
            setIsExpire(true);
        }
        return function() {
            return clearInterval(interval);
        };
    }, [
        timeLeft
    ]);
    var handleClearTimer = function() {
        setIsCleared(true);
    };
    var minutes = String(Math.floor(timeLeft / 60)).padStart(2, "0");
    var seconds = String(timeLeft % 60).padStart(2, "0");
    var leftTime = "".concat(minutes, ":").concat(seconds);
    return {
        leftTime: leftTime,
        isExpire: isExpire,
        handleClearTimer: handleClearTimer,
        isCleared: isCleared
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTimer);


/***/ }),

/***/ 17999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ MarkdownViewer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36664);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41120);
/* harmony import */ var rehype_raw__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39234);




var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(theme) {
    return {
        root: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(15),
            lineHeight: "1.73em",
            "& h1": {
                fontSize: theme.typography.pxToRem(30),
                lineHeight: "1.5em",
                fontWeight: "bold",
                marginBottom: 10
            },
            "& h2": {
                lineHeight: "1.5em",
                fontSize: theme.typography.pxToRem(15),
                fontWeight: "bold",
                marginBottom: 10,
                marginTop: 30
            },
            "& h3": {
                fontSize: theme.typography.pxToRem(15),
                fontWeight: "bold"
            },
            "& h4": {
                marginTop: 10,
                fontSize: theme.typography.pxToRem(15),
                fontWeight: "bold",
                textAlign: "right"
            },
            "& ol": {
                paddingInlineStart: "2em"
            },
            "& li": {
                color: theme.palette.text.secondary
            },
            "& ul": {
                paddingInlineStart: "2em",
                listStyle: "circle"
            },
            "& p": {
                color: theme.palette.text.secondary
            },
            "& hr": {
                backgroundColor: "#e8e8e8",
                height: 1
            },
            "& a": {
                color: theme.palette.text.secondary
            },
            "& th": {
                padding: 8
            },
            "& td": {
                padding: 8
            }
        }
    };
});
var MarkdownViewer = function(param) {
    var content = param.content;
    var classes = useStyles();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_2__/* .ReactMarkdown */ .D, {
        className: classes.root,
        rehypePlugins: [
            rehype_raw__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
        ],
        children: content
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MarkdownViewer);


/***/ }),

/***/ 47742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ MARKETING_SMS; }
/* harmony export */ });
var MARKETING_SMS = "\n# 마케팅 정보 SMS/MMS 수신 동의 (선택)\n\n---\n## **1. 수집 및 이용 목적**\n\n회원이 수집 및 이용에 동의한 개인정보를 활용하여, SMS/MMS 등 다양한 전자적 전송매체를 통해 회원에게 유용한 혜택, 이벤트, 광고 정보를 전송할 수 있습니다.\n\n\n## **2. 수집하는 개인정보 항목**\n\n필수 동의사항에서 개인정보 수집 및 이용에 동의한 항목\n\n\n## **3. 보유 및 이용기간**\n\n회원탈퇴를 요청하거나 개인정보의 수집 및 이용에 대한 동의를 철회하는 경우, 수집 및 이용목적이 달성되거나 이용기간이 종료한 경우 개인정보를 지체 없이 파기합니다.\n\n단, 상법 등 관계법령의 규정에 의하여 보존할 필요가 있는 경우 법령에서 규정한 보존기간 동안 거래내역과 최소한의 기본정보를 보유합니다.\n\n\n## **4. 수신동의 거부 및 철회방법 안내**\n\n본 동의는 거부하실 수 있습니다. 다만 거부 시 동의를 통해 제공 가능한 각종 혜택, 이벤트 안내를 받아보실 수 없습니다.\n\n본 수신동의를 철회하고자 할 경우에는 메일링/문자메시지 설정 페이지에서 수신여부를 변경하실 수 있습니다.\n\n\n";


/***/ }),

/***/ 55999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @desc 검색어 입력 debounce hook
 * @returns debounce callback
 */ var useDebounce = function(callback, delay) {
    var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(value) {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(function() {
            if (value !== "") {
                callback(value);
            }
        }, delay);
    }, [
        callback,
        delay
    ]);
};


/***/ }),

/***/ 19468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useOutSideClick; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/**
 * @desc 검색 결과에 따라 리스트를 표시한 뒤 다른 영역을 클릭하거나 esc, tab 키를 입력시 리스트를 닫도록 합니다.
 *
 */ var useOutSideClick = function(param) {
    var ref = param.ref, onOutsideClick = param.onOutsideClick, isActive = param.isActive, _isDeferOutSideClick = param.isDeferOutSideClick, isDeferOutSideClick = _isDeferOutSideClick === void 0 ? false : _isDeferOutSideClick;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleMouseDown = function(e) {
            if (isActive && ref.current && !ref.current.contains(e.target)) {
                if (isDeferOutSideClick) {
                    setTimeout(function() {
                        onOutsideClick();
                    }, 0);
                } else {
                    onOutsideClick();
                }
            }
        };
        var handleKeyDown = function(e) {
            if (isActive && (e.code === "Escape" || e.code === "Tab")) {
                onOutsideClick();
            }
        };
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            document.removeEventListener("mousedown", handleMouseDown);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        isActive,
        onOutsideClick,
        ref
    ]);
};


/***/ })

}]);